import { mainService, statisticsService } from '@/utils/request'

// 搜索主入口
export function searchMain (data) {
  return mainService({
    url: 'search/main',
    method: 'post',
    data: data,
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取详情
export function getDocDetail (id) {
  return mainService({
    url: `doc/${id}`,
    method: 'get',
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取搜索建议
export function getSearchSuggest (query) {
  return mainService({
    url: `search/suggest/${query}`,
    method: 'get',
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取搜索底纹
export function getSearcjHint () {
  return mainService({
    url: 'search/getHint',
    method: 'get',
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取热搜列表
export function getHotSearch (time) {
  return mainService({
    url: 'search/listStatisticLogs',
    method: 'get',
    params: {
      modelName: 'hot',
      ...time
    },
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取详情下方关系图数据
export function getDocGraph (id) {
  return mainService({
    url: `doc/graph/${id}`,
    method: 'get',
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 根据数据原始ID获取搜索系统中的id
export function getIdByOriginalId (originalId) {
  return mainService({
    url: `doc/switch/${originalId}`,
    method: 'get',
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取首页热词雷达左侧数据
export function hotWordLeftChartData (time) {
  return mainService({
    url: 'search/hotSearchList',
    method: 'get',
    params: {
      ...time
    },
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取首页热词雷达右侧数据
export function hotWordRightListData (time) {
  return mainService({
    url: 'search/keyWordAgg',
    method: 'get',
    params: {
      ...time
    },
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取首页搜索框下方的统计数据
export function getStatisticsList () {
  return statisticsService({
    url: 'overview',
    method: 'get',
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取筛选菜单的筛选条件
export function getSearchFilter (data) {
  return statisticsService({
    url: 'getSearchOptions',
    method: 'get',
    params: data,
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取详情文章的原始数据
export function getDocOriginalDetail (id) {
  return statisticsService({
    url: `getArticle?article_id=${id}`,
    method: 'get',
    headers: { logintoken: localStorage.getItem('token') }
  })
}

// 获取登录密钥vicode
export function getLoginVicode () {
  return mainService({
    url: 'user/getVerifyCode',
    method: 'get'
  })
}
// 用户登录
export function loginSearchSys (data) {
  return mainService({
    url: 'user/login',
    method: 'post',
    data: data
  })
}
// 退出登录
export function loginoutsys (token) {
  return mainService({
    url: `user/logout?login_token=${token}`,
    method: 'get'
  })
}
